import LazyLoad from "vanilla-lazyload";
import * as AOS from "aos";
import Header from "@modules/Header";
import MobileNavigation from "@modules/MobileNavigation";
import LanguageSwitcher from "@modules/LanguageSwitcher";
import Footer from "@modules/Footer";
import ModalToggle from "@modules/ModalToggle";
var lazyLoadInstance = new LazyLoad({
// Your custom settings go here
});
AOS.init();
new Header();
new MobileNavigation();
new LanguageSwitcher();
new Footer();
new ModalToggle();
